function updateStep2Data(data) {
  data.forEach((item) => {
    const element = document.querySelector(`.${item.label}`);
    if (element) {
      element.textContent = item.value || "--";
      if (item.label === 'remain_date_value' && (item.value <= 5 || item.value === '期限切れ' || item.value === 'Expired')) {
        element.closest(".info-value").classList.add("highlight-red");
        const unit = document.querySelector('.date_unit')
        if ((item.value === '期限切れ' || item.value === 'Expired') && unit) {
          unit.classList.add('hide')
        }
      }
    }
  });
}

// Step 1 (信息确认) 的按钮处理
const toStep1 = document.getElementById("toStep1");
if (toStep1) {
  toStep1.addEventListener("click", () => {
    const stepWizard = document.querySelector("step-wizard");
    if (stepWizard) {
      stepWizard.activateStep(1); // 回到 Step 0 (信息输入)
    }
  });
}

// Step 1 (信息确认) 的下一步按钮
// const toStep2 = document.getElementById("toStep2");
// if (toStep2) {
//   toStep2.addEventListener("click", () => {
//     const stepWizard = document.querySelector("step-wizard");
//     if (stepWizard) {
//       stepWizard.activateStep(3); // 跳转到 Step 2 (商品选择)
//     }
//     const url = new URL(window.location);
//     const active_id = url.searchParams.get("active_id");
//     sessionStorage.setItem('active_code', active_id)
//     const isRoaming = localStorage.getItem('isRoaming')
//   });
// }
toStep2.addEventListener("click", () => {
  const url = new URL(window.location);
  const active_id = url.searchParams.get("active_id");
  sessionStorage.setItem('active_code', active_id)
  const isRoaming = localStorage.getItem('isRoaming')
  if (isRoaming) {
    if (localStorage.getItem('isUnlimited')) {
      window.location.href = `${window.location.origin}/products/korea-esim-max-recharge`
    } else {
      window.location.href = `${window.location.origin}/collections/roaming-recharge`
    }
  } else {
    Message.error('現地カードはチャージに対応しておりません。')
    // window.location.href = `${window.location.origin}/collections/local-recharge`
  }
});

function step2Fetch(active_id) {
  fetch(apiUrl + active_id)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((res) => {
      if (res.code === 200) {
        const value = res.data.productEntity;
        let remain_data = "--";
        try {
          const dataKB = JSON.parse(res.data.quotaGB).result;
          remain_data = (dataKB / 1000 / 1000 / 1000).toFixed(2);
        } catch (e) {
          remain_data = "--";
        }
        const lang = document.documentElement.getAttribute('lang')
        const expirationTime = getRemainDate(value.expirationTime) <= 0 ? lang === 'ja' ? '期限切れ' : 'Expired' : item.value
        const data = [
          { label: "region_value", value: value.country },
          { label: "plan_value", value: value.salePlanName },
          {
            label: "expiration_date_value",
            value: formatDate(value.expirationTime),
          },
          {
            label: "remain_date_value",
            value: expirationTime,
          },
          { label: "remain_data_value", value: remain_data },
        ];
        updateStep2Data(data);
      } else {
        throw new Error(res?.msg || "Request error! status: " + res.code);
      }
    })
    .catch((err) => {
      Message.error(err);
    });
}

function getStep2Data() {
  const url = new URL(window.location);
  const step = url.searchParams.get("step");
  const active_id = url.searchParams.get("active_id");
  const product_id = url.searchParams.get("product_id");
  if (step === "2") {
    if (active_id) {
      const region_value = document.querySelector(".region_value");
      if (region_value.innerText === "--") {
        step2Fetch(active_id);
      }
    }
  }
}

// 重写 history.pushState 和 history.replaceState 来监听URL变化
(function () {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function (state, title, url) {
    originalPushState.apply(history, arguments);
    // 触发自定义事件
    window.dispatchEvent(
      new CustomEvent("urlchange", { detail: { url, state } })
    );
  };

  history.replaceState = function (state, title, url) {
    originalReplaceState.apply(history, arguments);
    // 触发自定义事件
    window.dispatchEvent(
      new CustomEvent("urlchange", { detail: { url, state } })
    );
  };
})();

function init() {
  getStep2Data();

  window.addEventListener("popstate", (event) => {
    getStep2Data();
  });

  window.addEventListener("urlchange", (event) => {
    getStep2Data();
  });
}

document.addEventListener("DOMContentLoaded", init);
